import axios from "axios";

const request = axios.create({
  baseURL:'/tusglu',
  // baseURL:
  //   process.env.NODE_ENV === "production"
  //     ? process.env.VUE_APP_REQUEST_URL
  //     : "/api",
  timeout: 3600000, // 1小时
  withCredentials: true,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.error(error)
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    //拦截响应，做统一处理
    // const { code } = response.data;
    // if (code !== 0) {
    //   switch (code) {
    //     case 9002:
    //     case 604:
    //       router.replace("/login");
    //       break;

    //     default:
    //       Message({
    //         message: response.data.msg,
    //         type: "error",
    //         duration: 2000,
    //       });
    //       break;
    //   }
    // }
    // return response.data.data;
      return response.data;
  },
  //接口错误状态处理，也就是说无响应时的处理
  (error) => {
    return Promise.reject(error); // 返回接口返回的错误信息
  }
);

export default request;
